import { RouterProvider } from "react-router-dom";
import { modifiedUnAuthorizedRoutes } from "./routes";

export const UnAuthenticatedUser = () => {
  return <RouterProvider router={modifiedUnAuthorizedRoutes} />;
};
